import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Details from "./Details";
import Summary from "./Summary";
import SectionDetailsLink from "../common/SectionDetailsLink";

function createSummaryRow(type, quantity) {
  return { type, quantity };
}

const summaryRows = [
  createSummaryRow("SMS", 2983),
  createSummaryRow("E-post", 1843),
  createSummaryRow("OneStream filatgard", 4500),
  createSummaryRow("OneStream preflight", 4500),
  createSummaryRow("OneStream dublettkontroll", 4500),
  createSummaryRow(
    "OneStream OneStream OneStream dublettkontroll dublettkontroll dublettkontroll",
    4500
  ),
  createSummaryRow("Prepressmodul poster", 4500),
];

function createDetailsRow(workspaceName, type, quantity, note) {
  return { workspaceName, type, quantity, note };
}

const detailsRows = [
  createDetailsRow("Batbyggaren 2355", "SMS", 2983, ""),
  createDetailsRow("Kanalen 32", "E-post", 1843, ""),
  createDetailsRow(
    "Siemens customer documentation",
    "Prepressmodul poster",
    4000,
    "Arbetsflode: MRB Parm 55 mm"
  ),
  createDetailsRow(
    "Siemens customer documentation",
    "Prepressmodul poster",
    500,
    "Arbetsflode: MR2 Parm 60 mm"
  ),
];

const VariableCostsSection = ({ classes }) => {
  const [openDetails, setOpenDetails] = useState(false);

  const toggleOpenDetails = () => {
    setOpenDetails(!openDetails);
  };

  return (
    <>
      <Typography className={classes.sectionTitle}>
        <FormattedMessage id="admin.subscriptions.variableCosts.title" />
      </Typography>
      <Grid container item xs={12} md={4}>
        <Summary className={classes.sectionSummary} rows={summaryRows} />
      </Grid>
      <SectionDetailsLink
        className={classes.sectionDetailsLink}
        onClick={toggleOpenDetails}
      />
      <Grid container item xs={12}>
        <Details
          className={classes.sectionDetails}
          open={openDetails}
          rows={detailsRows}
        />
      </Grid>
    </>
  );
};

VariableCostsSection.defaultProps = {
  classes: {},
};

VariableCostsSection.propTypes = {
  classes: PropTypes.object,
};

export default VariableCostsSection;
